export const LOAD_DEGREE_PROGRAMS = 'LOAD_DEGREE_PROGRAMS'
export const LOAD_MILITARY_STATUS = 'LOAD_MILITARY_STATUS'
export const LOAD_REGIONS = 'LOAD_REGIONS'
export const LOAD_DEGREE_OPTIONS = 'DEGREE_OPTIONS'
export const LOAD_COURSE_MODALITY = 'LOAD_COURSE_MODALITY'
export const LOAD_SCHOOL_SIZE = 'LOAD_SCHOOL_SIZE'
export const LOAD_HBCU_OPTIONS = 'LOAD_HBCU_OPTIONS'
export const LOAD_USER_DEGREE_TYPE = 'LOAD_USER_DEGREE_TYPE'
export const LOAD_NOTIFICATIONS = 'LOAD_NOTIFICATIONS'
export const SET_SDN_AGREE = 'SET_SDN_AGREE'
export const SET_DISCOUNT_NUMBER = 'SET_DISCOUNT_NUMBER'
